export default "__VITE_ASSET__91ec28a7__"